import { Space } from 'antd';
import styled from 'styled-components';

export const ContainMainPageWrapper = styled.div`
  .queuedSamples-btn {
    .quantity-info {
      padding: 0 8px;
      background-color: var(--light-pink);
      border: 1px solid var(--primary);
      border-radius: 12px;
    }
  }

  .nav-kit-left-side {
    overflow-x: auto;
  }
`;

export const ContainBodyWrapper = styled.div`
  margin: var(--default-margin-table);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 40px - 20px - 100px);
  justify-content: space-between;
`;

export const DotWrapper = styled(Space)`
  /* color: var(--color); */
  font-weight: 600;
`;

export const Dot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  display: flex;
  border-radius: 50%;
  background-color: ${p => p.color};
`;

export const KitReceivedTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-left: 12px;
`;

export const KitReceivedContent = styled.div`
  margin-left: 2rem;
`;

export const DotIcon = styled.div<{
  completed: boolean;
  colors: string[];
}>`
  width: 6px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${p => (p.completed ? p.colors[0] : p.colors[1])};
`;

export const DelayContent = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
`;

export const ScannedKitsMessageWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;

  padding-inline-start: 24px;
  margin-bottom: 24px;
`;

export const ScannedKitsDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  gap: 16px;

  .ant-btn {
    margin-top: 12px;
  }
`;
